import { TelegramClient } from "./types"

export const WebApp = (window as Window & typeof globalThis & { Telegram: TelegramClient }).Telegram.WebApp
